import ListItem from './ListItem.vue';
import TableUsers from './TableUser.vue';

export default {
    ListItem,
    TableUsers
}